import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddIcCallIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_ic_call"}/>
}
